import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { get, set, del } from 'idb-keyval';

import { getQueryCacheKey } from './userScope';

/**
 * Cria um persister de query cache escopado por userId.
 * Cada usuário tem sua própria chave no idb-keyval.
 */
export function createUserQueryPersister(userId: string) {
  const key = getQueryCacheKey(userId);

  return createAsyncStoragePersister({
    storage: {
      getItem: async (k: string) => {
        // O persister sempre chama com a key configurada,
        // mas usamos a key scoped por userId diretamente
        const value = await get(k);
        return value ?? null;
      },
      setItem: async (k: string, value: string) => {
        await set(k, value);
      },
      removeItem: async (k: string) => {
        await del(k);
      },
    },
    key,
  });
}
